import { useCallback, useEffect, useState } from 'react';
import { Article, articlesService } from '../../../apiServices/articles.service';

export const useArticle = (id: any) => {
  const [article, setArticle] = useState<Article | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchArticle = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      const data = await articlesService.getById(id);
      setArticle(data);
    } catch (err) {
      setError('Error loading article');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchArticle();
  }, [fetchArticle]);

  return {
    article,
    loading,
    error,
    refetch: fetchArticle,
  };
};